import { h, } from '@stencil/core';
import cn from 'classnames';
import { join, scrollToComponent, store, setLinearProductData, ACTION_TYPES, getLocaleFromBody, EAvailabilityType, EApcButtonType, ETabType, ESectionHeaderColors, EQdsButtonImportance, EQdsButtonSize, } from '@pes-ui/utils';
import { isBrowser, isMobile } from '../../globals/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../globals/stickyBar.utils';
import { getApcCta } from '../../globals/apc-cta/api';
import { addToCart, formCtaUrl } from '../../globals/apc-cta/utils';
import { getStickyBarMapping } from '../product-description-page/utils';
export class PesProductsFilter {
  constructor() {
    this.updateActiveProductData = async (relationTypeKey) => {
      var _a;
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      const { data: filtersData, relationType, sectionTitle, showMoreLabel, showLessLabel, sortByLabel, selectLabel, defaultRecordCount, } = data[activeProductTab][relationTypeKey];
      this.data = filtersData;
      this.relationType = relationType;
      this.sectionTitle = sectionTitle;
      this.showMoreLabel = showMoreLabel;
      this.showLessLabel = showLessLabel;
      this.sortByLabel = sortByLabel;
      this.selectLabel = selectLabel;
      this.defaultRecordCount = defaultRecordCount;
      if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length))
        return;
      this.setupTabbar();
      this.setCategoryData();
      this.loadInitialRecords();
    };
    this.renderViewMore = () => {
      return (this.showViewMoreLabel && (h("div", { class: "specifications__view-more-wrapper" }, h("pes-view-more-link", { viewMoreLabel: `${this.showMoreLabel} (${this.selectedCategoryProducts.length - this.defaultRecordCount})`, viewLessLabel: this.showLessLabel, isExpanded: this.isExpanded }))));
    };
    this.getApcPrices = (productId) => {
      var _a, _b;
      if (!productId) {
        return null;
      }
      if (!((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[productId])) {
        return null;
      }
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = this.productAvailabilityInfo.prices[productId];
      return {
        priceLabel,
        previousPriceValue,
        VATInclused,
        previousPrice,
        activePrice,
        activePriceNoTax,
        activePriceValue,
      };
    };
    this.getActivePrice = (productId) => {
      if (this.isAPCSite) {
        return this.renderApcPrices(productId);
      }
    };
    this.renderSectionContent = () => {
      return (h("div", { class: "section_content" }, this.products.map((product) => (h("div", { class: "product-container" }, h("div", { class: "service-product-card" }, h("qds-standalone-link", { href: product.productUrl, importance: EQdsButtonImportance.STANDARD, size: EQdsButtonSize.STANDARD }, product.description), h("a", { class: "service-product-card__link", href: product.productUrl }, h("p", { class: "service-product-card-name" }, product.name))), this.productAvailabilityInfo && (h("div", { class: "price-cta-container" }, this.renderPrices(product.name), this.renderCTAArea(product.name))))))));
    };
    this.getButtonType = (productId) => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[productId !== null && productId !== void 0 ? productId : '']) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
        default:
          return null;
      }
    };
    this.handleClick = (event, productId) => {
      var _a, _b, _c, _d;
      addToCart(event, productId, this.buildLocale(), (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.failedResponse, this.agentChatCscId);
    };
    this.data = undefined;
    this.selectedCategoryProducts = [];
    this.sectionTitle = undefined;
    this.categoryData = [];
    this.products = [];
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.selectLabel = undefined;
    this.sortByLabel = undefined;
    this.isExpanded = false;
    this.showViewMoreLabel = true;
    this.isMobile = isMobile();
    this.defaultRecordCount = 2;
    this.isAPCSite = false;
    this.apcCta = undefined;
    this.productAvailabilityInfo = undefined;
    this.loading = true;
    this.commerceConnectorSettings = null;
    this.giftId = null;
    this.apcCtaUrl = undefined;
    this.relationType = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.host = '';
    this.agentChatCscId = undefined;
    this.arrowsOverlay = undefined;
  }
  getProductIds() {
    return this.data.map((item) => item.name).join('%7C');
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.apcCtaUrl) {
      const { isApcSite, apcCtaUrl, agentChatCscId } = event.detail;
      this.isAPCSite = isApcSite;
      this.apcCtaUrl = apcCtaUrl;
      this.agentChatCscId = agentChatCscId;
      if (this.isAPCSite && this.apcCtaUrl) {
        this.requestApcCta(this.apcCtaUrl);
      }
    }
  }
  componentDidLoad() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length))
      return;
    this.setupTabbar();
  }
  buildLocale() {
    if (this.countryCode && this.languageCode) {
      return join('/', this.countryCode, this.languageCode);
    }
    const locale = getLocaleFromBody(isBrowser);
    return locale
      ? join('/', locale.countryCode, locale.languageCode)
      : '';
  }
  async requestApcCta(apcCtaUrl) {
    let locale = null;
    if (this.countryCode && this.languageCode) {
      locale = {
        countryCode: this.countryCode,
        languageCode: this.languageCode,
      };
    }
    else {
      locale = getLocaleFromBody(isBrowser);
    }
    this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, locale));
  }
  setCategoryData() {
    var _a;
    this.categoryData = [{ label: this.selectLabel, value: '' }];
    const uniqueCategories = {};
    (_a = this.data) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
      if (uniqueCategories[item.category]) {
        return;
      }
      uniqueCategories[item.category] = { label: item.categoryLabel, value: item.category };
      this.categoryData.push({ label: item.categoryLabel, value: item.category });
    });
    this.categoryData.sort((a, b) => a.value.localeCompare(b.value));
  }
  componentWillLoad() {
    this.setCategoryData();
    this.loadInitialRecords();
    if (!this.relationType)
      return;
    const relationTypeKey = this.relationType;
    store.dispatch(setLinearProductData({ [relationTypeKey]: {
        data: this.data,
        relationType: this.relationType,
        sectionTitle: this.sectionTitle,
        showMoreLabel: this.showMoreLabel,
        showLessLabel: this.showLessLabel,
        sortByLabel: this.sortByLabel,
        selectLabel: this.selectLabel,
        defaultRecordCount: this.defaultRecordCount,
      } }));
    this.unsubscribe = store.subscribe(async () => this.updateActiveProductData(relationTypeKey));
  }
  setupTabbar() {
    const tabtype = getStickyBarMapping(this.relationType);
    if (!tabtype || !this.sectionTitle)
      return;
    setStickyBarTab(tabtype, [this.sectionTitle]);
    this.observe();
  }
  handleTabClicked(event) {
    if (this.productsfilterRef && event.detail.type === ETabType.LIFECYCLE_CAROUSEL) {
      scrollToComponent(this.productsfilterRef);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.productsfilterRef, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        setTabActive({ type: ETabType.LIFECYCLE_CAROUSEL, title: this.sectionTitle });
        this.setTabActive.emit();
      }
    });
  }
  getDefaultCount(data) {
    return this.defaultRecordCount !== -1 ? this.defaultRecordCount : data.length;
  }
  loadInitialRecords() {
    var _a;
    this.products = (_a = this.data) === null || _a === void 0 ? void 0 : _a.slice(0, this.getDefaultCount(this.data));
    this.selectedCategoryProducts = JSON.parse(JSON.stringify(this.data));
  }
  handleToggleViewMore(e) {
    this.isExpanded = e.detail;
    if (!(this.isExpanded && this.showViewMoreLabel)) {
      this.productsfilterRef.scrollIntoView(true);
      this.products = this.selectedCategoryProducts.slice(0, this.getDefaultCount(this.selectedCategoryProducts));
    }
    else {
      this.products = JSON.parse(JSON.stringify(this.selectedCategoryProducts));
    }
  }
  changeCategory(selectedCategory) {
    if (selectedCategory.detail.selectedValue !== '') {
      this.selectedCategoryProducts = this.data.filter((item) => item.category === selectedCategory.detail.selectedValue);
    }
    else {
      this.selectedCategoryProducts = JSON.parse(JSON.stringify(this.data));
    }
    if (!this.isExpanded) {
      this.products = this.selectedCategoryProducts.slice(0, this.getDefaultCount(this.data));
    }
    else {
      this.products = JSON.parse(JSON.stringify(this.selectedCategoryProducts));
    }
  }
  renderApcPrices(productId) {
    var _a, _b;
    const prices = this.getApcPrices(productId);
    return (prices && (h("pes-cta-price", { previousPriceVariant: "beside", class: "cta-area__price_filter", priceHTML: prices.activePrice, previousPriceHTML: prices.previousPrice, vatLabel: (prices === null || prices === void 0 ? void 0 : prices.VATInclused) ? (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.vatLabel : '', variant: "list" })));
  }
  renderPrices(productId) {
    if (this.isAPCSite) {
      return (h("div", { class: cn('prices', this.isMobile && 'prices--mobile') }, this.getActivePrice(productId)));
    }
  }
  renderApcAddToCartButton(productId) {
    var _a, _b;
    const addToCartButtonLabel = ((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel) || 'Add to Cart';
    return (this.getButtonType(productId) && (h("pes-cta-button", { class: "cta-area__button", importance: EQdsButtonImportance.EMPHASIZED, size: EQdsButtonSize.LARGE, text: addToCartButtonLabel, onDidClick: (event) => this.handleClick(event.detail, productId) })));
  }
  renderPrimaryCTA(productId) {
    if (this.isAPCSite) {
      if (this.productAvailabilityInfo && this.getButtonType(productId)) {
        return this.renderApcAddToCartButton(productId);
      }
    }
  }
  renderCTAArea(productId) {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__buttons" }, this.renderPrimaryCTA(productId))));
  }
  handleResize() {
    this.isMobile = isMobile();
  }
  renderProductsFiltersContent() {
    return (h("div", null, h("span", { class: "sort-label" }, !this.isMobile && this.sortByLabel), h("pes-select", { items: this.categoryData, onSelectedValue: (value) => this.changeCategory(value) }), this.renderSectionContent(), this.selectedCategoryProducts.length > this.defaultRecordCount
      && this.renderViewMore()));
  }
  disconnectedCallback() {
    var _a;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length))
      return null;
    return (h("pes-section-with-header", { headingLabel: this.sectionTitle, withColumns: !this.isMobile, isInProductsFilters: true, color: ESectionHeaderColors.FUCHSIA }, this.renderProductsFiltersContent()));
  }
  static get is() { return "pes-products-filter"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["products-filters.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["products-filters.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "resolved": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "references": {
            "IProductCardIdRegular": {
              "location": "import",
              "path": "../products-carousel/types"
            },
            "IProductCardIdSoftware": {
              "location": "import",
              "path": "../products-carousel/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "sectionTitle": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "section-title",
        "reflect": false
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-less-label",
        "reflect": false
      },
      "selectLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-label",
        "reflect": false
      },
      "sortByLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sort-by-label",
        "reflect": false
      },
      "defaultRecordCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "default-record-count",
        "reflect": false,
        "defaultValue": "2"
      },
      "isAPCSite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-a-p-c-site",
        "reflect": false,
        "defaultValue": "false"
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CommerceConnectorSettings | null",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "relationType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "relation-type",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false,
        "defaultValue": "''"
      },
      "agentChatCscId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "agent-chat-csc-id",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "selectedCategoryProducts": {},
      "categoryData": {},
      "products": {},
      "isExpanded": {},
      "showViewMoreLabel": {},
      "isMobile": {},
      "loading": {},
      "giftId": {},
      "arrowsOverlay": {}
    };
  }
  static get events() {
    return [{
        "method": "apcCtaButtonDidClick",
        "name": "apcCtaButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TApcAddToCartEvent",
          "resolved": "TApcCtaButtonEvent & { productId: string; bundle?: { bundleId: string; qty: number; }; }",
          "references": {
            "TApcAddToCartEvent": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        }
      }, {
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "productsfilterRef"; }
  static get listeners() {
    return [{
        "name": "ccGetOptionsSucceeded",
        "method": "onCcGetOptionsSucceeded",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "didToggleViewMore",
        "method": "handleToggleViewMore",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "resize",
        "method": "handleResize",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
